import React, { useState } from "react";
import "./TextField.css";
import eyeIcon from "@assets/images/icons/eye.png";

const TextField = ({
  label,
  placeholder,
  onChange,
  onKeyDown,
  disabled = false,
  style,
  onClick,
  name,
  className = "",
  type = "text",
  value,
  showToggleIcon = true,
  id,
  ariaLabel,
  autoComplete,
  required = false,
  readOnly = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const inputType = type === "password" && showPassword ? "text" : type;

  return (
    <div className={`text-field-wrapper ${className}`}>
      {label && <label className="text-field-label">{label}</label>}
      <input id={id} aria-label={ariaLabel} autoComplete={autoComplete} required={required} readOnly={readOnly} placeholder={placeholder ?? ""} onChange={onChange} onKeyDown={onKeyDown} name={name} disabled={disabled} style={style} className="text-field" type={inputType} value={value} />
      {type === "password" && showToggleIcon && (
        <button
          type="button"
          className="eye-toggle"
          aria-label={showPassword ? "Hide password" : "Show password"}
          aria-pressed={showPassword}
          disabled={disabled}
          onClick={handleTogglePassword}
        >
          <img src={eyeIcon} alt="" className="eye-icon" />
        </button>
      )}
    </div>
  );
};

export default TextField;
